import { Checkbox, TextField } from '@symphony-ui/uitoolkit-components';
import LabelPlacements from '@symphony-ui/uitoolkit-components/components/selection/LabelPlacements';
import * as React from 'react';
import { numberRegex } from 'utils/validation';
const FixedRateEditor = ({ value, onChange }) => {
    const [fixed, setFixed] = React.useState(value?.value.toString() ?? '');
    const [indicative, setIndicative] = React.useState(value?.indicative ?? false);
    const set = React.useCallback((newValue) => {
        const newFixedRate = newValue.value !== '' && !newValue.value.endsWith(".") ?
            { value: Number.parseFloat(newValue.value), indicative: newValue.indicative } : undefined;
        onChange({ target: { value: newFixedRate } });
    }, [onChange]);
    const onChangeValue = React.useCallback((event) => {
        const newValue = event.target.value;
        if (numberRegex.exec(newValue) !== null) {
            setFixed(newValue);
        }
        set({ value: newValue, indicative });
    }, [indicative, set]);
    const onClickIndicative = React.useCallback(() => {
        setIndicative(currentIndic => {
            set({ value: fixed, indicative: !currentIndic });
            return !currentIndic;
        });
    }, [set, fixed]);
    const inputRef = React.useRef(null);
    React.useEffect(() => {
        const { current } = inputRef;
        if (current !== null) {
            current.focus();
        }
    }, []);
    return (React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between' } },
        React.createElement(TextField, { label: "Value", onChange: onChangeValue, ref: inputRef, value: fixed }),
        React.createElement("div", { className: 'co-checkbox-compact' },
            React.createElement(Checkbox, { label: "Indic.", labelPlacement: LabelPlacements.TOP, name: "indicative", onClick: onClickIndicative, value: indicative ? 'true' : 'false' }))));
};
export default FixedRateEditor;
